/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Required/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'



/** @type {import('Simple/types.js').View} */
export default function Required({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content/Editor/Content/EditArea/QuestionFields/Content/Required"
  
}) {
let questionRequiredValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'required',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let dtTypographyFontweightBold = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontWeight.bold'
        })
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 justifyContent="flex-start"
 data="question.required"
 value={questionRequiredValueData}
 onChange={onChange}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 text="Required"
 fontWeight={dtTypographyFontweightBold}
/>
</React.Fragment>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}